import React from 'react';
import UserActionFunctional from './component/useraction-functional';
import './userAction.scss';

const UserAction = () => {
	return <UserActionFunctional />;
};
export default UserAction;
